import { EventLog } from "@/api";

export const EVENT_TITLES = {
  [EventLog.EEventType.staffShiftCreated]: "Shift created",
  [EventLog.EEventType.staffShiftUpdated]: "Shift updated",
  [EventLog.EEventType.staffShiftDeleted]: "Shift deleted",
  [EventLog.EEventType.noteUpdated]: "Note updated",
  [EventLog.EEventType.openShiftCreated]: "Open Shift created",
  [EventLog.EEventType.openShiftUpdated]: "Open Shift updated",
  [EventLog.EEventType.openShiftDeleted]: "Open Shift deleted",
} as const;
